module.exports = __webpack_public_path__ + "static/kran01_1024-6b6ff59150f1a1d761631b3e518f25e4.jpg";